module.exports = __webpack_public_path__ + "static/media/bunny-win.449ae385.jpeg";